import * as CommonTypes from "../types/common.types";
import http from "./http-common";

class SellerServiceClass {
    private token: string | undefined;
    private config: { headers: { Authorization: string | undefined } };
    private seller: string = '/seller'
    private passenger: string = '/passenger'
    private tours: string = '/tours'
    private trips: string = '/trips'
    private guider: string = '/guider'
    private driver: string = '/driver'
    private reservation: string = '/reservation'
    private group: string = '/group'
    private payment: string = '/payments'
    private cash: string = '/cash'
    constructor(token?: string) {
        this.token = token;
        this.config = { headers: { Authorization: `Bearer ${this.token}` } };
    }
    
    setToken(token: string) {
      this.token = token;
      this.config = { headers: { Authorization: `Bearer ${this.token}` } };
    }

    login(data: CommonTypes.DefaultLogin) {
      return http.post(this.seller + '/login', data)
    }

    createPassenger(data: Partial<CommonTypes.Passenger>) {
      return http.post(this.passenger + '/create', data, this.config)
    }

    createReservation(data: CommonTypes.SubmitReservation) {
      return http.post(this.reservation + '/create', data, this.config)
    }

    listPassengers() {
      return http.get(this.passenger, this.config)
    }

    listTours(date: string) {
      return http.post(this.tours + '/listToursTripsPassengers', {date}, this.config)
    }
    
    getPassengerPlan(id: string) {
      return http.get(this.passenger + `/passenger-plan?passenger_id=${id}`, this.config)
    }

    getReservation(reservation_id: string) {
      return http.get(this.reservation + `/reservation/${reservation_id}`, this.config)
    }

    createGroup() {
      return http.post(this.group + '/create', {}, this.config)
    }

    me() {
      return http.get(this.seller + '/me', this.config)
    }

    editReservation(reservation_id: string, data: CommonTypes.Reservation) {
      return http.put(this.reservation + `/edit/${reservation_id}`, data, this.config)
    }

    deleteReservation(reservation_id: string) {
      return http.delete(this.reservation + `/delete/${reservation_id}`, this.config)
    }

    getPaymentsInfo(start_date: Date, end_date?: Date) {
      return http.post(this.seller + '/paymentsInfo', {start_date, end_date}, this.config)
    }

    // payments

    createReservationPayment(data: FormData) {
      return http.post(this.payment + '/create-reservation-payment', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    listReservationPayments(reservation_id: string) {
      return http.get(this.payment + `/list-reservation-payments/${reservation_id}`, this.config)
    }

    editReservationPayment(payment_reservation_id: string, data: FormData) {
      return http.put(this.payment + `/edit-reservation-payment/${payment_reservation_id}`, data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    deleteReservationPayment(payment_reservation_id: string) {
      return http.delete(this.payment + `/delete-reservation-payment/${payment_reservation_id}`, this.config)
    }

    // caja (apertura/cierre de turno)

    getCheckpointStatus(shift_date: Date | string) {
      return http.get(this.cash + '/register/status', {...this.config, params: { shift_date }})
    }

    previewApertura(shift_date: Date | string, period: 'AM' | 'PM') {
      return http.get(this.cash + '/register/apertura/preview', {...this.config, params: { shift_date, period }})
    }

    registerApertura(shift_date: Date | string, period: 'AM' | 'PM', counted_amount: number) {
      return http.post(this.cash + '/register/apertura', { shift_date, period, counted_amount }, this.config)
    }

    previewCierre(shift_date: Date | string, period: 'AM' | 'PM') {
      return http.get(this.cash + '/register/cierre/preview', {...this.config, params: { shift_date, period }})
    }

    registerCierre(shift_date: Date | string, period: 'AM' | 'PM', counted_amount: number) {
      return http.post(this.cash + '/register/cierre', { shift_date, period, counted_amount }, this.config)
    }

    // caja (movimientos de Efectivo, solo mientras está en turno)

    listCashCategories(flow_type?: 'ingreso' | 'egreso') {
      return http.get(this.cash + '/seller/categories', {...this.config, params: flow_type ? { flow_type } : undefined})
    }

    getCashAccount() {
      return http.get(this.cash + '/seller/cash-account', this.config)
    }

    createCashMovement(data: FormData) {
      return http.post(this.cash + '/seller/movements', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    listCashMovements(shift_date: Date | string, period: 'AM' | 'PM') {
      return http.get(this.cash + '/seller/movements', {...this.config, params: { shift_date, period }})
    }

    listDaysWorked(from: Date, to: Date) {
      return http.get(this.cash + '/seller/days-worked', {...this.config, params: { from, to }})
    }

}

const SellerService = new SellerServiceClass()

export default SellerService